import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
import React from "react";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Link } from "~/features/ui/link";
import { formatArticleTeaserDate } from "~/features/date/utils";
import { IconButton } from "~/features/ui/icon-button";
import Plus from "~/public/icons/plus.svg";
const fragment = graphql(`
  fragment ArticleTeaser on article_default_Entry {
    id
    url
    title
    date: postDate
  }
`);
export function ArticleTeaser(props: FragmentType<typeof fragment>) {
  const {
    url,
    title,
    date,
    id
  } = useFragment(fragment, props);
  const hoverId = `id-${id}`;
  return <_StyledLink href={url} id={hoverId}>
      <_StyledDiv>
        <_StyledSpan>
          {formatArticleTeaserDate(date)}
        </_StyledSpan>
        <_StyledP>{title}</_StyledP>
      </_StyledDiv>
      <IconButton as="div" icon={{
      component: Plus,
      style: {
        "transitionProperty": "transform",
        "transitionDuration": "250ms",
        "transitionTimingFunction": "ease-in-out"
      },
      onHoverStyle: {
        "--tw-rotate": "90deg",
        "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
      }
    }} hoverId={hoverId} />
    </_StyledLink>;
}
var _StyledLink = _styled(Link).withConfig({
  componentId: "sc-sf-3tpou5-0"
})({
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "columnGap": "1.6rem",
  "padding": "1.6rem",
  "@media (min-width: 1024px)": {
    "height": "7.2rem",
    "paddingTop": "2.4rem",
    "paddingBottom": "2.4rem",
    "paddingLeft": "2.4rem",
    "paddingRight": "1.6rem"
  }
});
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-3tpou5-1"
})({
  "display": "flex",
  "flex": "1 1 0%",
  "alignItems": "center",
  "columnGap": "1.6rem"
});
var _StyledSpan = _styled3("span").withConfig({
  componentId: "sc-sf-3tpou5-2"
})({
  "textWrap": "nowrap",
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.2rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.024rem",
  "fontWeight": "400",
  "color": "rgba(255, 255, 255, 0.5)",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.028000000000000004rem",
    "fontWeight": "400"
  }
});
var _StyledP = /*#__PURE__*/_styled4("p").withConfig({
  displayName: "article-teaser___StyledP",
  componentId: "sc-1m7gujs-0"
})({
  "width": "100%",
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "overflow": "hidden",
    "display": "-webkit-box",
    "WebkitBoxOrient": "vertical",
    "WebkitLineClamp": "2"
  }
});